// extracted by mini-css-extract-plugin
export default {"badge":"UpgradeBadge_badge__OHQ-n"};